/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

import { inject } from '@angular/core';
import { CanActivateFn, createUrlTreeFromSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { isCluster2x } from '@shared/domain/cluster';
import { clusterById } from '../ngrx';

export const only2xClustersGuard =
  (clusterIdParamName: string, command: any[] = ['..']): CanActivateFn =>
  (route) => {
    const store = inject(Store);
    const redirectTo = createUrlTreeFromSnapshot(route, command);

    const clusterId = route.params[clusterIdParamName];
    const cluster = store.selectSignal(clusterById(clusterId))();
    if (!cluster) return redirectTo;
    const is2x = isCluster2x(cluster);
    return is2x ? true : redirectTo;
  };
